import { render, staticRenderFns } from "./CaseItem.vue?vue&type=template&id=65202d15&"
import script from "./CaseItem.vue?vue&type=script&lang=js&"
export * from "./CaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports